import React, { useState, useContext, useCallback, useEffect, memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import logo from '../../assets/image/lego1.webp';
import {
    FaInstagram, FaTelegram, FaSearch,
    FaTimes, FaBars
} from 'react-icons/fa';

function Navbar({ pageType = 'cosmetic' }) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [scrolled, setScrolled]     = useState(false);
    const [searchVal, setSearchVal]   = useState('');
    const { theme } = useContext(ThemeContext);
    const location  = useLocation();
    const navigate  = useNavigate();

    /* تشخیص اسکرول برای افکت شیشه‌ای */
    useEffect(() => {
        let ticking = false;
        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    setScrolled(window.scrollY > 40);
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    /* بستن منو هنگام تغییر مسیر */
    useEffect(() => { setMobileOpen(false); }, [location.pathname]);

    const menuItems = {
        cosmetic: [
            { title: 'صفحه اصلی',  href: '/cosmetics',  route: true  },
            { title: 'خدمات ما',   href: '#resume',     route: false },
            { title: 'محصولات',    href: '#ci',         route: false },
            { title: 'آموزش',      href: '/train',      route: true  },
            { title: 'مارکتینگ',   href: '/Marketing',  route: true  },
            { title: 'درباره ما',  href: '/about',      route: true  },
            { title: 'تماس با ما', href: '/contact',    route: true  },
        ],
        beauty: [
            { title: 'صفحه اصلی',     href: '/beauty',              route: true  },
            { title: 'خدمات ما',      href: '#services',            route: false },
            { title: 'پوست و مو',     href: '/service/5',           route: true  },
            { title: 'لاغری',         href: '/service/4',           route: true  },
            { title: 'پزشکان زیبایی', href: '/service/1',           route: true  },
            { title: 'درباره ما',     href: '/about?from=beauty',   route: true  },
            { title: 'تماس با ما',    href: '/contact?from=beauty', route: true  },
        ],
    };

    const items = menuItems[pageType] || menuItems.cosmetic;

    const isActive = (href) =>
        href.startsWith('/') && location.pathname === href;

    const toggleMenu = useCallback(() => setMobileOpen(v => !v), []);

    return (
        <>
            {/* ── Top Bar ── */}
            <div className="nb-topbar">
                <div className="nb-topbar__inner">
                    {/* شعار برند */}
                    <p className="nb-topbar__slogan">
                        ✦ دکتر سیمین — ایده، تولید، بازاریابی ✦
                    </p>

                    {/* جستجو */}
                    <form
                        className="nb-search"
                        onSubmit={e => {
                            e.preventDefault();
                            if (searchVal.trim()) {
                                navigate(`/search?q=${encodeURIComponent(searchVal.trim())}`);
                                setSearchVal('');
                            }
                        }}
                    >
                        <button type="submit" className="nb-search__submit" aria-label="جستجو">
                            <FaSearch className="nb-search__icon" />
                        </button>
                        <input
                            type="text"
                            placeholder="جستجو در سایت..."
                            value={searchVal}
                            onChange={e => setSearchVal(e.target.value)}
                            dir="rtl"
                        />
                    </form>

                    {/* لوگو */}
                    <Link to={pageType === 'beauty' ? '/beauty' : pageType === 'cosmetic' ? '/cosmetics' : '/'} className="nb-topbar__logo">
                        <img src={logo} alt="لوگو" />
                    </Link>

                </div>
            </div>

            {/* ── Main Navbar ── */}
            <nav className={`nb-nav${scrolled ? ' nb-nav--scrolled' : ''}`}>
                <div className="nb-nav__inner">

                    {/* لینک‌های منو */}
                    <ul className="nb-menu">
                        {items.map((item, i) => (
                            <li key={i} className="nb-menu__item">
                                {item.route
                                    ? (
                                        <Link
                                            to={item.href}
                                            className={`nb-menu__link${isActive(item.href) ? ' nb-menu__link--active' : ''}`}
                                            style={isActive(item.href) ? { color: '#111' } : {}}
                                        >
                                            {item.title}
                                            {isActive(item.href) && (
                                                <span className="nb-menu__dot" style={{ background: '#111' }} />
                                            )}
                                        </Link>
                                    ) : (
                                        <a href={item.href} className="nb-menu__link">
                                            {item.title}
                                        </a>
                                    )
                                }
                            </li>
                        ))}
                    </ul>

                    {/* شبکه‌های اجتماعی */}
                    <div className="nb-social">
                        <a href="https://www.instagram.com/drsimin_2" target="_blank" rel="noreferrer" className="nb-social__btn" aria-label="اینستاگرام">
                            <FaInstagram />
                        </a>
                        <a href="https://t.me/DrSiminTeam" target="_blank" rel="noreferrer" className="nb-social__btn" aria-label="تلگرام">
                            <FaTelegram />
                        </a>
                    </div>

                    {/* همبرگر */}
                    <button
                        className="nb-burger"
                        onClick={toggleMenu}
                        aria-label="باز کردن منو"
                        aria-expanded={mobileOpen}
                    >
                        {mobileOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
                    </button>
                </div>
            </nav>

            {/* ── موبایل: overlay + drawer ── */}
            {mobileOpen && (
                <div className="nb-overlay" onClick={() => setMobileOpen(false)} />
            )}
            <div className={`nb-drawer${mobileOpen ? ' nb-drawer--open' : ''}`}>
                <div className="nb-drawer__logo">
                    <img src={logo} alt="لوگو" width={72} height={72} />
                </div>
                <ul className="nb-drawer__list">
                    {items.map((item, i) => (
                        <li key={i}>
                            {item.route
                                ? (
                                    <Link
                                        to={item.href}
                                        className={`nb-drawer__link${isActive(item.href) ? ' nb-drawer__link--active' : ''}`}
                                        style={isActive(item.href) ? { color: theme.primary, borderColor: theme.primary } : {}}
                                    >
                                        {item.title}
                                    </Link>
                                ) : (
                                    <a href={item.href} className="nb-drawer__link" onClick={() => setMobileOpen(false)}>
                                        {item.title}
                                    </a>
                                )
                            }
                        </li>
                    ))}
                </ul>
                <div className="nb-drawer__social">
                    <a href="https://www.instagram.com/drsimin_2" target="_blank" rel="noreferrer"><FaInstagram /></a>
                    <a href="https://t.me/DrSiminTeam" target="_blank" rel="noreferrer"><FaTelegram /></a>
                </div>
            </div>
        </>
    );
}

export default memo(Navbar);
